module.exports = __webpack_public_path__ + "img/JEDC.46a96c88.svg";